import axios from 'axios';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import FileTypeUtil from './FileType';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.BASE_URL}pdf.worker.min.js`;

const blobUrlCache = new Map();

/**
 * @description PDF文件加载与缩略图渲染工具
 * @author fengtianhe1
 * @date 2026-07-06
 */
export default {
  /**
   * 通过下载接口获取文件Blob
   */
  async fetchFileBlob(path) {
    const downloadPath = FileTypeUtil.getDownloadPath(path);
    const request = axios.create({
      responseType: 'blob',
      headers: {
        token: sessionStorage.getItem('authorization'),
      },
    });
    const response = await request.post(
      `/Api/FileDownload?path=${encodeURIComponent(downloadPath)}`
    );
    return response.data;
  },

  /**
   * 获取PDF预览用的Blob URL，带缓存
   */
  async getPdfBlobUrl(path) {
    const cacheKey = FileTypeUtil.getDownloadPath(path);
    if (blobUrlCache.has(cacheKey)) {
      return blobUrlCache.get(cacheKey);
    }
    const blob = await this.fetchFileBlob(path);
    const url = window.URL.createObjectURL(
      new Blob([blob], { type: 'application/pdf' })
    );
    blobUrlCache.set(cacheKey, url);
    return url;
  },

  /**
   * 释放PDF Blob URL缓存
   */
  revokePdfBlobUrl(path) {
    const cacheKey = FileTypeUtil.getDownloadPath(path);
    const cachedUrl = blobUrlCache.get(cacheKey);
    if (cachedUrl) {
      window.URL.revokeObjectURL(cachedUrl);
      blobUrlCache.delete(cacheKey);
    }
  },

  /**
   * 渲染PDF首页为缩略图DataURL
   */
  async renderPdfThumbnail(path, width = 80, height = 80) {
    const blob = await this.fetchFileBlob(path);
    const arrayBuffer = await blob.arrayBuffer();
    const pdfDocument = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdfDocument.getPage(1);
    const viewport = page.getViewport({ scale: 1 });
    const scale = Math.min(width / viewport.width, height / viewport.height);
    const scaledViewport = page.getViewport({ scale });
    const canvas = document.createElement('canvas');
    canvas.width = scaledViewport.width;
    canvas.height = scaledViewport.height;
    await page.render({
      canvasContext: canvas.getContext('2d'),
      viewport: scaledViewport,
    }).promise;
    return canvas.toDataURL('image/png');
  },
};
